import { createContext, useContext, useEffect, useMemo, useState } from "react";

interface ContextProps {
	isLock: boolean;
	lock: (key: string) => void;
	unlock: (key: string) => void;
}

const Context = createContext<ContextProps>({
	isLock: false,
	lock: (key: string) => {},
	unlock: (key: string) => {},
});

const useGlobalScrollContext = () => useContext(Context);

export const useGlobalScrollIsLock = () => {
	const { unlock } = useGlobalScrollContext();

	return unlock;
};

export const useGlobalScrollLock = () => {
	const { lock } = useGlobalScrollContext();

	return lock;
};

export const useGlobalScrollUnlock = () => {
	const { unlock } = useGlobalScrollContext();

	return unlock;
};

interface Props {
	children: React.ReactNode;
}

export const GlobalScrollProvider = ({ children }: Props) => {
	const [lockKeys, setLockKeys] = useState<string[]>([]);

	const lockCount = useMemo(() => {
		return lockKeys.length;
	}, [lockKeys]);

	const isLock = useMemo(() => {
		return lockCount > 0;
	}, [lockCount]);

	const lock = (key: string) => {
		setLockKeys((lockKeys) => {
			let newArr = [...lockKeys, key];
			let uniqieArr = Array.from(new Set(newArr));

			return uniqieArr;
		});
	};

	const unlock = (key: string) => {
		setLockKeys((lockKeys) => {
			let newArr = lockKeys.filter((item) => item != key);

			return newArr;
		});
	};

	const contextData: ContextProps = {
		isLock,
		lock,
		unlock,
	};

	useEffect(() => {
		const html = document.getElementsByTagName("html")[0];
		const body = document.body;

		html.style.overflow = isLock ? "hidden" : "";
		body.style.overflow = isLock ? "hidden" : "";

		return () => {
			html.style.overflow = "";
			body.style.overflow = "";
		};
	}, [isLock]);

	return <Context.Provider value={contextData}>{children}</Context.Provider>;
};
